/**
 * @Date: 2020-05-25 18:44
 * @author jiabinbin
 * @Email 425605679@qq.com
 * @Description:
 */
import http from '../http'

export const queryCurrencyConfPageList = data => {
  return http.request({
    url: '/basic/queryCurrencyConfPageList',
    data,
    method: 'post'
  })
}

export const operateTimeQueryPage = data => {
  return http.request({
    url: '/basic/operateTimeQueryPage',
    data,
    method: 'post'
  })
}

// 营业时间更新
// export const operateTimeUpdate = data => {
//   return http.request({
//     url: '/basic/operateTimeUpdate',
//     data,
//     method: 'post'
//   })
// }

// 币种状态
export const updateCurrencyConf = data => {
  return http.request({
    url: '/basic/updateCurrencyConf',
    data,
    method: 'post'
  })
}
